import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function AnnouncementBar() {
  const {
    t
  } = useLanguage();
  return <div className="bg-cacao-800 text-creme" data-id="element-23" data-mp="olbvvtmvz4dd">
      <p className="mx-auto max-w-7xl px-6 py-2.5 text-center font-sans text-[11px] md:text-xs tracking-[0.12em] uppercase" data-id="element-24" data-mp="jttwvb4fbdv1">
        {t.announcement}
      </p>
    </div>;
}